var map = {
	"./federal-election-2025/LogoDesktop.svg": 2841,
	"./federal-election-2025/LogoMobile.svg": 2842,
	"./federal-election-2025/UpdatesSocial.jpg": 761,
	"./wa-election-2021/ElectoratesSocial.jpg": 2843,
	"./wa-election-2021/LogoDesktop.svg": 2844,
	"./wa-election-2021/LogoMobile.svg": 2845,
	"./wa-election-2021/PartyTotalsSocial.jpg": 2846,
	"./wa-election-2021/UpdatesSocial.jpg": 2847,
	"./wa-election-2025/ElectoratesSocial.jpg": 763,
	"./wa-election-2025/LogoDesktop.svg": 2848,
	"./wa-election-2025/LogoMobile.svg": 2849,
	"./wa-election-2025/PartyTotalsSocial.jpg": 764,
	"./wa-election-2025/UpdatesSocial.jpg": 762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2840;